import { Image, Text } from '@ui/atoms';
import React from 'react'

const AuthorDetails = ({ author }) => {
  return (
      <div className="w-full flex flex-col gap-4 mb-4" id='author-details'>
          <div className="flex items-center gap-4">
              <Image
                  src={author?.node?.avatar?.url}
                  alt="author"
                  className="w-16 h-16 rounded-xl"
              />
              <div className="flex flex-col gap-1">
                  <Text
                      content="AUTHOR"
                      className="text-secondary-500 p6-medium"
                  />
                  {author?.node?.firstName ? (
                      <Text
                          content={`${author?.node?.firstName} ${
                              author?.node?.lastName || ''
                          }`}
                          className="p3-semibold text-primary-500"
                      />
                  ) : null}
              </div>
          </div>
          <Text
              content={author?.node?.description}
              isInnerHtml
              className="p4-regular text-gray-800"
          />
      </div>
  );
}

export default AuthorDetails;